import dateValidators from './date.validators';
import phoneValidators from './phone.validators';
import timeValidators from './time.validators';

const email = (value) =>
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    value
  )
    ? ''
    : 'Ongeldige email formaat.';

const formValidators = {
  date: dateValidators,
  time: timeValidators,
  email,
  emailNonRequired: (value) => (value ? email(value) : ''),
  phoneSimple: phoneValidators.phoneSimple,
  required: (value) => (!value ? 'Veld is verplicht' : ''),
  maxLength: (value, maxLengthAllowed) =>
    value?.length > maxLengthAllowed ? `Er zijn maximaal ${maxLengthAllowed} tekens toegestaan` : '',
  attachmentUrl: (value) =>
    value?.startsWith('https://digipolis.sharepoint.com/')
      ? ''
      : 'Url moet beginnen met https://digipolis.sharepoint.com/'
};

export default formValidators;
